export default __webpack_public_path__ + "protect-sensitive-data.jpg";